import './stylesheets/styles.sass';
import Slider from './javascripts/components/Slider.jsx'
import PropertiesApp from './javascripts/components/properties-app/PropertiesApp.jsx';
import SimpleGoogleMap from './javascripts/components/SimpleGoogleMap.jsx';

import './javascripts/components/Accordion.jsx';
import './javascripts/components/MenuSelect.jsx';
import './javascripts/components/SmoothScroll.jsx';
import './javascripts/components/TenantsSelect.jsx';
import './javascripts/components/VideoStyle.jsx';
import './javascripts/components/MainNav.jsx';
import './javascripts/components/PropertyFilter.jsx';
import './javascripts/components/Lightbox.jsx';


// Lity lightbox
require('lity');

if(window.location.pathname == "/properties/operating-portfolio") {
  const propertiesApp = new PropertiesApp();
  propertiesApp.initPropertiesApp();
}

new Slider();

const simpleGoogleMap = new SimpleGoogleMap();
simpleGoogleMap.initGoogleMap();



// WEBPACK FOOTER //
// ./web/src/app/index.jsx